import React from 'react';

import { Box, Display, Flex, Heading } from '@rover/kibble/core';
import type { SeoLocationDetails } from '@rover/rsdk/src/apiClient/latest/model/seoLocationDetails';

import DogTrainingLandingSearchForm from '../../../../components/DogTrainingLandingSearchForm';
import { HERO_IMAGE_FLEX_BASIS, HeroImageWrapper } from '../../../components/SeoLocationHero';

export interface TrainingCityServiceHeroProps {
  seoLocationDetails: SeoLocationDetails;
  heroImage?: string;
}

const TrainingCityServiceHero: React.FC<TrainingCityServiceHeroProps> = ({
  seoLocationDetails,
  heroImage,
}) => {
  const { h1, h2 } = seoLocationDetails;

  return (
    <Flex
      position="relative"
      pt="8x"
      pb="0x"
      mb="2x"
      justifyContent={['center', 'space-between']}
      alignItems="center"
      width="100%"
    >
      <Flex
        width="100%"
        maxWidth="416px"
        justifyContent="center"
        flexDirection="column"
        flexBasis={['100%', '50%', '416px']}
      >
        <Display webProps={{ as: 'h1', responsive: false }} size="500" mb="4x">
          {h1}
        </Display>

        <Heading webProps={{ as: 'h2', responsive: false }} fontWeight="regular" size="300" mb="6x">
          {h2}
        </Heading>

        <DogTrainingLandingSearchForm />
      </Flex>

      {heroImage && (
        <Box display={['none', 'block']} flexBasis={HERO_IMAGE_FLEX_BASIS}>
          <HeroImageWrapper
            description=""
            height="auto"
            width="100%"
            src={heroImage}
            resizeMethod="contain"
            webProps={{ eager: true }}
          />
        </Box>
      )}
    </Flex>
  );
};

export default TrainingCityServiceHero;
